import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {toFarsiNumber} from "../../cudtom-hooks/en-to-persian";
import {callApiAgain, showPopUp, updatePending} from "../common-states/commonStatesSlice";
import {EnglishToPersian} from "numeral-convert";

const config = {
    headers: {Authorization: `Token ${localStorage.getItem('token')}`}
}
export const getDrivers = createAsyncThunk("driver/getDriver", async(data) => {
    const {searchParam, pageNum, dispatch} = data
    dispatch(updatePending(true))
    let bodyArray = [];
    await axios.get(`https://api.khedmatashayer-kj.ir/v1/driver/${pageNum}?${searchParam}`, config)
        .then((response) => {
            console.log(response.data)
            response.data && response.data.forEach((item) => {
                bodyArray = [
                    ...bodyArray,
                    [
                        <i className="fa fa-trash cursor-pointer text-base text-red-500" onClick={() => dispatch(deleteDriver({driverId: item.driver_id, dispatch}))}></i>,
                        <i className="fa fa-edit cursor-pointer text-base text-lime-500" onClick={() => dispatch(setDriverInfo({obj: item, type: 'showEditForm'}))}></i>,
                        <i className="fa fa-file-text-o cursor-pointer text-base text-gray-700" onClick={() => dispatch(setDriverInfo({obj: item, type: 'showHistory'}))}></i>,
                        toFarsiNumber(item.water_source_volume),
                        item.city,
                        toFarsiNumber(item.mobile),
                        toFarsiNumber(item.national_code),
                        item.name,
                    ],
                ];
            })
            dispatch(updatePending(false))
        })
        .catch(() => {
            alert('خطا در برقراری ارتباط با سرور')
        })
    return bodyArray
})

export const getDriverHistory = createAsyncThunk("driver/getDriverHistory", async(driverId) => {
    let historyArray = [];
    await axios.get(`https://api.khedmatashayer-kj.ir/v1/nomad/tanker-request/1?driver_id=${driverId}`, config)
        .then(res => {
            console.log(res.data)
            res.data.forEach(item => {
                let deliverDate, deliverTime;
                if(item.nomad_confirmed_at){
                    deliverDate = new Date(item.nomad_confirmed_at).toLocaleDateString('fa-IR');
                    deliverTime = EnglishToPersian(item.nomad_confirmed_at.slice(11));
                }
                let registerDate = new Date(item.created_at).toLocaleDateString('fa-IR');
                historyArray = [...historyArray, [toFarsiNumber(item.cost), toFarsiNumber(item.water_volume), deliverTime ?? '-', deliverDate ?? '-',
                    registerDate, item.water_type === 1 ? 'آب شرب' : 'آب دام', toFarsiNumber(item.region), toFarsiNumber(item.tanker_request_id),
                    toFarsiNumber(item.nomad.mobiles[0].mobile), item.nomad.name]]
            })
        })
        .catch(() => {
            alert('خطا در برقراری ارتباط با سرور')
        })
    return historyArray
})
export const getDriversByCity = createAsyncThunk(
  "driver/getDriversByCity",
  async (cityId, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `https://api.khedmatashayer-kj.ir/v1/driver?city_id=${cityId}`
      );

      return res.data; 

    } catch (error) {
      console.error(error);
      return rejectWithValue("خطا در دریافت راننده‌ها");
    }
  }
);
// const driverSliceByCity = createSlice({
//   name: "driverBycity",
//   initialState: {
//     drivers: [],
//     loading: false,
//     error: null,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(getDriversByCity.pending, (state) => {
//         state.loading = true;
//       })
//       .addCase(getDriversByCity.fulfilled, (state, action) => {
//         state.loading = false;
//         state.drivers = action.payload;
//       })
//       .addCase(getDriversByCity.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });
export const addOrEditDriver = createAsyncThunk(
    "driver/addOrEditDriver",
    async (data, { rejectWithValue }) => {
        const { commonData, driverId, registerBtnType, dispatch } = data;

        try {
            let response;

            if (registerBtnType === "ثبت") {
                response = await axios.post(
                    "https://api.khedmatashayer-kj.ir/v1/driver",
                    {
                        ...commonData,
                        created_at: new Date().toISOString(),
                    },
                    config
                );

                dispatch(callApiAgain(true));
                dispatch(showPopUp({ type: "showForm", value: false }));
            } else {
                response = await axios.put(
                    `https://api.khedmatashayer-kj.ir/v1/driver/${driverId}`,
                    commonData,
                    config
                );

                dispatch(callApiAgain(true));
                dispatch(showPopUp({ type: "showEditForm", value: false }));
            }

            alert(response.data.message);
            return response.data;
        } catch (err) {
            if (
                err.response?.data?.message?.includes(
                    "error : {'water_source_volume'"
                )
            ) {
                dispatch(
                    setVolumeError("حجم تانکر میتواند کمتر یا مساوی با 65535 لیتر باشد")
                );
            }

            alert(
                err.response?.data?.message ||
                err.message ||
                "خطایی رخ داده است."
            );

            return rejectWithValue(err.response?.data);
        }
    }
);
export const deleteDriver = createAsyncThunk("driver/deleteDriver", async(data) => {
    const {driverId, dispatch} = data
    let r = window.confirm("آیا برای حذف این مشترک اطمینان دارید؟");
    if(r === true){
        axios.delete(`https://api.khedmatashayer-kj.ir/v1/driver/${driverId}`, config)
            .then(res => {
                console.log(res.data)
                dispatch(callApiAgain(true))
                alert('مشترک موردنظر با موفقیت حذف شد!')
            })
            .catch(() => {
                alert('خطا در برقراری ارتباط با سرور')
            })
    }
})

const driverSlice = createSlice({
    name: 'driver',
    initialState: {
        bodyArray: [],         
        historyArray: [],
        selectedDriver: { obj: null, type: '' },
        volumeError: '',
        driverInputsState: null,
        loading: false,         
        error: null             
    },
    reducers: {
        setDriverInfo: (state, action) => {
            state.selectedDriver = action.payload
        },
        setVolumeError: (state, action) => {
            state.volumeError = action.payload
        },
        setDriverInputsState: (state, action) => {
            state.driverInputsState = action.payload
        }
    },
    extraReducers(builder){
        builder

            .addCase(getDriversByCity.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(getDriversByCity.fulfilled, (state, action) => {
                state.loading = false
                state.bodyArray = action.payload
            })
            .addCase(getDriversByCity.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })

            // 🔹 قبلی‌هات
            .addCase(getDrivers.fulfilled, (state, action) => {
                state.bodyArray = action.payload
            })
            .addCase(getDriverHistory.fulfilled, (state, action) => {
                state.historyArray = action.payload
            })
    }
})
export const {setDriverInfo, setVolumeError, setDriverInputsState} = driverSlice.actions
export const selectDriverBodyArray = state => state.driver.bodyArray
export const selectDriverHistoryArray = state => state.driver.historyArray
export const selectSelectedDriver = state => state.driver.selectedDriver
export const selectVolumeError = state => state.driver.volumeError
export const selectDriverInputsState = state => state.driver.driverInputsState

export default driverSlice.reducer